import React, {ReactNode} from 'react'
import MdEditor from 'react-markdown-editor-lite'
import MarkdownIt from 'markdown-it'
import 'react-markdown-editor-lite/lib/index.css'

interface propsType {
    errorText?: string
    height?: number
    label?: ReactNode
    onChange: (value: string) => void
    value: string
}

const mdParser = new MarkdownIt()

const MarkdownEditor = (props: propsType) => {
    const editorHandler = ({text}: {html: string; text: string}) => {
        props.onChange(text)
    }
    return <>
        {props.label ?
            <label className="form-label">{props.label}</label>
            :
            null
        }
        <MdEditor
            style={{height: `${props.height || 400}px`}}
            value={props.value}
            renderHTML={(text) => mdParser.render(text)}
            onChange={editorHandler}
        />
        {props.errorText !== '' ?
            <div className="invalid-feedback">{props.errorText}</div>
            :
            null
        }
    </>
}

export default MarkdownEditor
